<template>
  <div class="login-container">
    <el-form :model="form" ref="loginForm" label-width="80px" class="login-form">
      <h2>登录</h2>
      <el-form-item label="用户名" prop="username">
        <el-input v-model="form.username"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input type="password" v-model="form.password" @keyup.enter.native="handleLogin"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleLogin">登录</el-button>
      </el-form-item>
    </el-form>
    <div >
      <footers/>
    </div>
  </div>
</template>

<script>
import footers from '../components/footer.vue'
export default {
  components: {   
    footers
  },
  data() {
    return {
      form: {
        username: '',
        password: ''
      }
    };
  },
  methods: {
    handleLogin() {
      this.$http.post('/api/login', this.form)
        .then(response => {
          if (response.success) {
            const role = response.role;
            localStorage.setItem('role', role);
            this.$router.push('/');
            this.$nextTick(() => {
              this.$root.$emit('reloadMenu');
            });
          } else {
            this.$message.error('登录失败：用户名或密码错误');
          }
        })
        .catch(error => {
          console.error('There was an error!', error);
          this.$message.error('请求失败，请检查网络连接');
        });
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  /* background-image: url('/vistors/frontend/public/bgc.jpg'); 替换为你的背景图片 */
  background-size: cover;
  background-position: center;
}

.login-form {
  width: 300px;
  padding: 30px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

h2 {
  text-align: center;
  margin-bottom: 20px;
}

</style>